<template>
  <div>
    <div class=" position-relative">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid  px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-green">
                  <div class="w-100">
                    <div class="row no-gutters">
                      <div class="col-8 py-14px">
                        <div class="w-100 pl-3">
                          <router-link :to="'/'+getMerchant().code" class="d-inline-block align-middle">
                            <img src="../../assets/img/icon/back-white.png" width="20" />
                          </router-link>
                          <p class="d-inline-block align-middle text-white heading-6 mb-0 ml-2">{{getMerchant().name}}</p>
                        </div>
                      </div>
                      <div class="col-4 text-right py-14px">
                        <div class="w-100 pr-3">
                          <p @click="is_show = !is_show" class="body-2 text-white mb-0 cursor-pointer mt-1">
                            {{$t('merchant.change-filter')}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <template v-if="is_show">
                  <div class="container bg-white">
                    <div class="col-100 py-2 pt-3">
                      <div class="rounded-6 p-1 text-center cursor-pointer box-shadow-bold border mb-4 border-green">
                        <div class="row no-gutters">
                          <div class="col-6" @click="changeRoadType('one_away')">
                            <p class="mb-0 body-2-1 py-2 d-block rounded-6" :class="{'text-white bg-green': filter.trip_type == 'one_away','text-green': filter.trip_type != 'one_away'}">{{$t('merchant.one-way')}}</p>
                          </div>
                          <div class="col-6" @click="changeRoadType('return')">
                            <p class="mb-0 body-2-1 py-2 d-block rounded-6" :class="{'text-white bg-green': filter.trip_type == 'return','text-green': filter.trip_type != 'return'}">{{$t('merchant.return-trip')}}</p>
                          </div>
                        </div>
                      </div>
                      <loader v-if="route.is_load" />
                      <template v-else>
                        <div class="row no-gutters mb-4">
                          <div class="col-6">
                            <div class="w-100 pr-2">
                              <p class="mb-0 body-3-3-1">{{$t('merchant.from')}} :</p>
                              <v-select class="filter" :clearable="false" :options="route.list.from" v-model="filter.from" label="name" :selectable="option => option.level == 2">
                                 <template v-slot:option="option">
                                    <div :class="{'pl-2': option.level == 2}">{{ option.name }}</div>
                                 </template>
                              </v-select>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="w-100 pl-2">
                              <p class="mb-0 body-3-3-1">{{$t('merchant.to')}} :</p>
                              <v-select class="filter" :disabled="is_from_empty" :clearable="false" :options="filtered_parent_route" v-model="filter.to" label="name" />
                            </div>
                          </div>
                        </div>
                        <div class="w-100 mb-4 pb-2" style="border-bottom: 1px solid #9BA1AA !important;">
                          <p class="mb-0 body-3-3-1">{{$t('merchant.departure')}} :</p>
                          <v-date-picker
                            ref='calendar'
                            v-model='filter.departure'
                            :min-date='min_departure'
                            :popover="{ visibility: 'click' }"
                            color='green'
                            >
                            <div class="row no-gutters">
                              <div class="col-7">
                                <p class="mb-0 body-2-1 mt-2">{{formatDate(filter.departure)}}</p>
                              </div>
                              <div class="col-5">
                                <p class="mb-0 ml-auto d-table text-green body-3-1 py-1 px-3 rounded-6 text-center border-green">
                                {{$t('merchant.change-date')}}</p>
                              </div>
                            </div>
                          </v-date-picker>
                        </div>
                        <div v-if="filter.trip_type == 'return'" class="w-100 mb-4 pb-2" style="border-bottom: 1px solid #9BA1AA !important;">
                          <p class="mb-0 body-3-3-1">{{$t('merchant.return')}} :</p>
                          <v-date-picker
                            ref='calendar-2'
                            v-model='filter.return'
                            :min-date='filter.departure'
                            :popover="{ visibility: 'click' }"
                            color='green'
                            >
                            <div class="row no-gutters">
                              <div class="col-7">
                                <p class="mb-0 body-2-1 mt-2">{{formatDate(filter.return)}}</p>
                              </div>
                              <div class="col-5">
                                <p class="mb-0 ml-auto d-table text-green body-3-1 py-1 px-3 rounded-6 text-center border-green">
                                {{$t('merchant.change-date')}}</p>
                              </div>
                            </div>
                          </v-date-picker>
                        </div>
                        <div class="w-100">
                          <p class="p-3 body-15 text-white text-center rounded-6 mb-0" :class="{'bg-green cursor-pointer':is_filter_form_valid,'bg-green-disabled cursor-disabled':!is_filter_form_valid}" @click="changeFilter()" >{{$t('merchant.search-ticket')}}</p>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="break bg-green"></div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-8 p-3">
      <div class="row no-gutters rounded-6 p-1 box-shadow-bold border border-green py-3" v-if="!is_saved_filter_empty">
        <div class="col-5 text-center">
          <p class="pl-3 mb-0 body-1-2 mt-1 d-block text-truncate">{{getTicketFilter().from.name}}</p>
        </div>
        <div class="col-2 text-center">
          <img src="../../assets/img/icon/right-arrow.png" width="30">
        </div>
        <div class="col-5 text-center">
          <p class="pr-3 mb-0 body-1-2 mt-1 d-block text-truncate">{{getTicketFilter().to.name}}</p>
        </div>
        <div class="col-12 mt-3 pt-3 border-top-dashed" v-if="getTicketFilter().trip_type == 'one_away'">
          <div class="w-100">
            <p class="mb-0 ml-3 float-left body-2-2">{{$t('merchant.departure')}}</p>
            <p class="mb-0 mr-3 float-right body-2-4">{{formatDate(getTicketFilter().departure)}}</p>
          </div>
        </div>
        <div class="col-6 mt-3 pt-3 text-center border-top-dashed" v-if="getTicketFilter().trip_type == 'return'">
          <p class="mb-0 body-3-3-1">{{$t('merchant.departure')}}</p>
          <p class="mb-0 body-2-4">{{formatDate(getTicketFilter().departure)}}</p>
        </div>
        <div class="col-6 mt-3 pt-3 text-center border-top-dashed" v-if="getTicketFilter().trip_type == 'return'">
          <p class="mb-0 body-3-3-1">{{$t('merchant.return')}}</p>
          <p class="mb-0 body-2-4">{{formatDate(getTicketFilter().return)}}</p>
        </div>
      </div>
      <p class="mb-0 d-block body-2-2 mt-5 text-center" v-else>{{$t('warning-message.filter-not-complete.message')}}</p>
    </div>
    <div class="break bg-green"></div>
    <loader v-if="ticket.is_load" />
    <div v-else class="container p-3">
      <p v-if="ticket.list.departure.length == 0" class="mb-0 d-block body-2-2 mt-3 text-center">{{$t('warning-message.ticket-not-found.message')}}</p>
      <template v-else>
        <template v-if="filter.trip_type == 'return'">
          <p class="body-2-2-1 pb-2 mb-3 border-bottom-dashed" v-if="ticket.list.departure_selected == ''">{{$t('merchant.select-departure')}}</p>
          <p class="body-2-2-1 pb-2 mb-3 border-bottom-dashed" v-else>{{$t('merchant.departure')}}</p>
        </template>
        <template v-for="item in ticket.list.departure">
          <ticket 
            :data="item" 
            @transport-selected="toggleOtherTicket('departure',item.id)" 
            @transport-unselected="toggleOtherTicket('departure','')" 
            @load-return="loadTicketList('return')" 
            v-if="ticket.list.departure_selected == '' || ticket.list.departure_selected == item.id">    
          </ticket>
          <span id="return-list-view" v-if="ticket.list.departure_selected == item.id"></span>
        </template>
      </template>
    </div>
    <div class="break bg-green" v-if="ticket.list.departure_selected != ''"></div>
    <template v-if="getTicketTransportReturn()">
      <loader v-if="ticket.is_return_load" />
      <div v-else class="container p-3">
        <p v-if="ticket.list.return.length == 0" class="mb-0 d-block body-2-2 mt-3 text-center">{{$t('warning-message.ticket-not-found.message')}}</p>
        <template v-else>
          <p class="body-2-2-1 pb-2 mb-3 border-bottom-dashed" v-if="ticket.list.return_selected == ''">{{$t('merchant.select-return')}}</p>
          <p class="body-2-2-1 pb-2 mb-3 border-bottom-dashed" v-else>{{$t('merchant.return')}}</p>
          <template v-for="item in ticket.list.return">
            <ticket 
              :data="item" 
              @transport-selected="toggleOtherTicket('return',item.id)" 
              @transport-unselected="toggleOtherTicket('return','')" 
              :is_variant="false" 
              v-if="ticket.list.return_selected == '' || ticket.list.return_selected == item.id">
            </ticket>
          </template>
        </template>
      </div>
    </template>
    <span id="return-view" class="d-block" :class="{'mb-5 pb-5': ticket.is_return_load}"></span>
    <floating-cart></floating-cart>
  </div>
</template>
<script>
  import {mapGetters, mapActions, mapMutations} from "vuex";
  import {customFormatDateTime} from '@/utils/index.js';
  import {get,post} from '@/services/index.js';
  import moment from 'moment';
  import Ticket from '@/components/ticket/Ticket';
  import FloatingCart from '@/components/general/FloatingCart'
  export default {
    components:{
      Ticket,
      FloatingCart
    },
    data() {
      return {
        ticket:{
          list: {
            departure: [],
            departure_selected: '',
            return_selected: '',
            return: []
          },
          is_load: false,
          is_return_load: false
        },
        warning_merchant_notfound_show: false,
        is_show: false,
        filter:{
          trip_type: "one_away",
          from: {},
          to: {},
          departure: new Date(),
          return: moment().add(1,'d').toDate(),
        },
        min_departure: new Date(),
        route: {
          is_load: false,
          list: {
            from: [],
            to: []
          }
        }
      }
    },
    mounted(){
      document.getElementById('ticket').scrollIntoView({
          behavior: 'smooth'
      });
      this.loadRoute().then(routeRes=>{
        if(routeRes){
          this.setFilter();
        }
      })
      if (this.is_saved_filter_empty){
        this.is_show = true
      }else{
        this.loadTicketList('one_away')
      }
      if(this.getTicketCart().qty > 0){
        this.ticket.list.departure_selected = this.getTicketCart().ticket_details[0].ticket.id
        if(this.getTicketCart().ticket_details.length > 1){
          this.loadTicketList('return')
          this.ticket.list.return_selected = this.getTicketCart().ticket_details[1].ticket.id
        }
      }
    },
    created(){
      
    },
    computed:{
      filtered_parent_route(){
        return this.route.list.to.filter(x=>x.id != this.filter.from.reference_id)
      },
      is_from_empty(){
        let data = (Object.keys(this.filter.from).length == 0) ? true : false
        return data;
      },
      filter_departure(){
        return this.filter.departure
      },
      filter_from_id(){
        return this.filter.from.id
      },
      is_filter_form_valid(){
        let data = false
        if (Object.keys(this.filter.from).length != 0 && Object.keys(this.filter.to).length != 0){
          data = true
        }
        return data
      },
      is_saved_filter_empty(){
        return (Object.keys(this.getTicketFilter().from).length == 0 && Object.keys(this.getTicketFilter().to).length == 0) ? true : false
      }
    },
    watch:{
      filter_departure(){
        if (moment(this.filter.return).isBefore(this.filter.departure)){
          this.filter.return = moment(this.filter.departure).add(1,'d').toDate();
        }
      },
      filter_from_id(){
        if(this.filter.from.reference_id == this.filter.to.id){
          this.filter.to = {}
        }
      }
    },
    methods:{
      // vuex func
      ...mapGetters(['getMerchant','getTicketFilter','getTicketCart','getTicketTransportReturn']),
      ...mapActions(['ticketSetFilterTransport','ticketListAddAct','ticketResetItemCart','ticketListPushAct','ticketResetItemCart']),
      ...mapMutations(['ticketSetTransportReturn']),

      // manipulation data
      formatDate(date){
        return customFormatDateTime(date,null,'ddd, DD MMM YYYY')
      },
      setFilter(){
        let copied_data = JSON.parse(JSON.stringify(this.getTicketFilter()))
        this.filter = copied_data;
        this.filter.departure = moment(copied_data).toDate()

        // check filter from
        if(Object.keys(this.filter.from).length > 0){
          let check_data_from = this.route.list.from.find(x => x.id === this.filter.from.id)
          if(Object.keys(check_data_from).length > 0){
            this.filter.from = check_data_from
          }
        }

        // check filter to
        if(Object.keys(this.filter.to).length > 0){
          let check_data_to = this.route.list.to.find(x => x.id === this.filter.to.id)
          if(Object.keys(check_data_to).length > 0){
            this.filter.to = check_data_to
          }
        }

        // check filter departure
        let today = new Date()
        if(moment(this.filter.departure).isSameOrAfter(today)){
          this.filter.departure = moment(this.filter.departure).toDate()
        }

        // check filter return
        if(moment(this.filter.return).isSameOrAfter(today)){
          this.filter.return = moment(this.filter.return).toDate()
        }else if(moment(this.filter.return).isBefore(today)){
          this.filter.return = moment(this.filter.deparute).add(1,'d').toDate()
        }
      },
      loadRoute(){
        return new Promise(success=>{
          this.route.is_load = true
          get("CORE","merchant-route/"+this.getMerchant().id).then(response=>{
            let res = response.data
            if (res.success) {
              for(let i = 0; i < res.data.length;i++){

                let copied_parent = Object.assign({}, res.data[i])
                copied_parent.level = 1
                delete copied_parent.child
                this.route.list.from.push(copied_parent)
                this.route.list.to.push(copied_parent)

                if(res.data[i].child.length > 0){
                  for(let j = 0; j < res.data[i].child.length;j++){
                    let copied_child = Object.assign({}, res.data[i].child[j])
                    copied_child.level = 2
                    this.route.list.from.push(copied_child)
                  }
                }

              }
              success(true)
            }else{
              success(false)
            }
            this.route.is_load = false
          })
        })
      },
      changeFilter(){
        if(this.is_filter_form_valid){
          this.ticketSetFilterTransport({
            type: 'update',
            data: this.filter
          })
          this.setFilter()
          this.is_show = !this.is_show

          // load new ticket list
          this.loadTicketList('one_away')
          this.ticketResetItemCart()
        }
      },
      loadTicketList(trip_type){
        let params = {
          merchant:this.getMerchant().id,
          from: this.getTicketFilter().from.id,
          to: this.getTicketFilter().to.id,
          date: moment(this.getTicketFilter().departure).format("YYYY-MM-DD"),
          min_availability:0
        }
        if(trip_type == 'return'){
          document.getElementById('return-view').scrollIntoView({
              behavior: 'smooth'
          });
          this.ticketSetTransportReturn(true)
          this.ticket.is_return_load = true
          this.ticket.list.return = []
          let min_availability = 0
          let variant_selected = []
          for(let i = 0; i < this.getTicketCart().ticket_details[0].variant.length;i++){
            min_availability += this.getTicketCart().ticket_details[0].variant[i].qty
            variant_selected.push(this.getTicketCart().ticket_details[0].variant[i].data.variant_id)
          }

          params.from = this.getTicketCart().ticket_details[0].variant[0].data.route_to.reference_id
          params.to = this.getTicketCart().ticket_details[0].variant[0].data.route_from.id
          params.date = moment(this.getTicketFilter().return).format("YYYY-MM-DD")
          params.min_availability = min_availability
          params.variants = variant_selected
        }else{
          this.ticketSetTransportReturn(false)
          this.ticket.is_load = true
          this.ticket.list = {
            return:[],
            departure: [],
            departure_selected: '',
            return_selected: ''
          }
        }

        post("CORE","ticket-transport",params).then(response=>{
          let res = response.data;
          if(trip_type == 'return'){
            this.ticketListPushAct({
              type: 'reset'
            })
            this.ticketListPushAct({
              type: 'push',
              data: res.data
            })
            for(let j = 0;j < res.data.length;j++){
              let copied_ticket = res.data[j]
              copied_ticket.ticket_transport_type = 'return'
              this.ticket.list.return.push(copied_ticket)
            }
            setTimeout(() => {this.toBottomView()},1)
            this.ticket.is_return_load = false
          }else{
            this.ticketListAddAct(res.data)
            for(let i = 0;i < res.data.length;i++){
              let copied_ticket = res.data[i]
              copied_ticket.ticket_transport_type = 'departure'
              this.ticket.list.departure.push(copied_ticket)
            }
            this.ticket.is_load = false
          }
        })
      },

      // action
      goToHome(){
        this.$router.push({
          path: '/'  
        })
      },
      changeRoadType(data){
        this.filter.trip_type = data
      },
      filterSubmit(){
        if(this.is_filter_form_valid){
          this.is_show = false
        }
      },
      toggleOtherTicket(type,id){
        if(type == 'departure'){
          this.ticket.list.departure_selected = id
          if(id == ''){
            this.ticketSetTransportReturn(false)
            this.ticketResetItemCart()
          }
        } 
        else if(type == 'return') this.ticket.list.return_selected = id
        else {
          this.ticket.list.departure_selected = ''
          this.ticket.list.return_selected = ''
        }
      },
      toBottomView(){
        document.getElementById('return-list-view').scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }

</script>
<style scoped>
  .border-top-dashed{
    border-top: 1px dashed #dee2e6;
  }
  .rotate-90{
    transform: rotate(90deg);
  }
  .rotate-270{
    transform: rotate(270deg);
  }
  .filter-dropdown{
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: auto;
    display: table;
  }
  .border-green{
    border-color: rgb(170, 212, 106) !important;
  }
  .break {
    background-color: #e9ebf2;
    height: 6px;
    border-top: 1px solid #e2e2e2;
  }

  .color-black {
    color: #000 !important;
  }

  .color-bold-light {
    color: #000000A6;
  }

  .plus-min-set input {
    margin-top: 10px;
  }

@media only screen and (max-width: 321px){
    .counter{
      width: 25px !important;
    }
  }

  @media only screen and (min-width: 600px){
    .counter{
      text-align: right !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ticket/TicketTransport.vue